export default __webpack_public_path__ + "static/media/dulces_detail2.69d4e760.jpg";